import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=5d87b1aa&scoped=true&"
import script from "./RadioButtons.vue?vue&type=script&lang=js&"
export * from "./RadioButtons.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtons.vue?vue&type=style&index=0&id=5d87b1aa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87b1aa",
  null
  
)

export default component.exports